import { Language } from '@/types/language';
import { getLanguage } from '@/utils/languageUtils';
import carTestSv from '../locales/sv/carTest.json';
import carTestEn from '../locales/en/carTest.json';

export const carTestLabels = (lang?: Language) => {
  const language = lang ?? getLanguage();
  return language === 'en' ? carTestEn : carTestSv;
};
